import OkC from "shared/util/OkcApi";
import noop from "shared/util/noop";

class OkInstagram {
	static initCbs = [];
	static initializing = false;
	static initialized = false;

	static init(cb) {
		if (this.initialized) {
			if (cb) {
				cb();
			}

			return;
		}

		if (cb) {
			this.initCbs.push(cb);
		}

		if (this.initializing) {
			return;
		}

		this.initializing = true;

		const options = {
			api: 1,
		};

		// First check if their instagram token is stored on the server.
		OkC.api("/social/instagram/status", options)
			.then((response) => {
				if (response.ok) {
					this.ready();
				} else {
					// Otherwise, open a window to authenticate
					this.connect();
				}
			});
	}

	static ready() {
		this.initializing = false;
		this.initialized = true;
		this.initCbs.map((cb) => cb());
	}

	// Connect your OkC account to instagram via a login window. Second arg will
	// mark the account for activation as well.
	static connect(cb, arg2) {
		let activate;
		let onFailure;
		let onSuccess;

		if (typeof cb === "function") {
			onSuccess = cb;
			onFailure = noop;
			activate = arg2;
		} else if (cb && typeof cb === "object") {
			({ onSuccess, onFailure, activate } = cb);
		}

		if (onSuccess) {
			this.initCbs.push(onSuccess);
		}

		window.okinstagram_cb = (token) => {
			const data = { token };

			if (activate) {
				data.activate = true;
			}

			const options = {
				api: 1,
				data,
			};

			return OkC.post("/social/instagram/connect", options)
				.then(() => this.ready())
				.catch(onFailure);
		};

		return window.open(
			"/okphotos/okinstagram.html",
			"okinstagram",
			"height=570,width=780",
		);
	}

	// Disconnect OKC account from instagram.
	static disconnect(cb) {
		const options = {
			api: 1,
		};

		return OkC.delete("/social/instagram/disconnect", options)
			.then(() => {
				this.initialized = false;
			})
			.then(cb);
	}

	// Mark account for showing instagram feed.
	static activate(cb) {
		const options = {
			api: 1,
		};

		return OkC.post("/social/instagram/activate", options)
			.then(cb);
	}

	// Disable showing instagram feed. Keep credentials.
	static deactivate(cb) {
		const options = {
			api: 1,
		};

		return OkC.post("/social/instagram/deactivate", options)
			.then(cb);
	}

	// Hit an instagram API path
	static api(path, _params = {}, _cb) {
		let params = _params;
		let cb = _cb;

		if (typeof _params === "function") {
			params = {};
			cb = _params;
		}

		const options = {
			api: 1,
			data: {
				path,
				params,
			},
		};

		return OkC.post("/social/instagram", options)
			.then(cb)
			.catch(cb);
	}
}

export default OkInstagram;




// WEBPACK FOOTER //
// ./src/shared/modules/OkInstagram.js